const SolidDivider = () => <div className="solid-divider" />;

export default SolidDivider;
